jQuery(function ($) {
    let currentGallery = 1;
    let currentIndex = 0;
    let images = [];

    // === GALÉRIA – PREPÍNANIE TYPU ===
    function openGallery( $tab, updateUrl ) {
        if ( !$tab.length ) return;

        let index = $tab.data('index');

        $('.gallery--header--navigation li').removeClass('active-item');
        $tab.addClass('active-item');

        $('.gallery--grid--body').removeClass('active');
        $('.gallery--grid--body[data-gallery="' + index + '"]').addClass('active');

        currentGallery = index;

        // adresa nech sa dá zdieľať, bez poskočenia stránky
        if ( updateUrl && window.history && history.replaceState ) {
            history.replaceState( null, '', '#' + $tab.data('slug') );
        }
    }

    // otvorenie konkrétnej záložky priamo z adresy, napr. /galeria/#virtualna-prehliadka
    function openFromUrl() {
        let slug = decodeURIComponent( ( window.location.hash || '' ).replace( '#', '' ) );

        if ( !slug ) return false;

        let $tab = $('.gallery--header--navigation li[data-slug="' + slug + '"]');

        if ( !$tab.length ) return false;

        openGallery( $tab, false );
        return true;
    }

    if ( !openFromUrl() ) {
        $('.gallery--grid--body[data-gallery="1"]').addClass('active');
    }

    $(window).on('hashchange', openFromUrl);

    $('.gallery--header--navigation li').on('click', function () {
        openGallery( $(this), true );
    });

    // === LIGHTBOX ===
    $('.gallery-grid--item').on('click', function () {
        let galleryType = $(this).closest('.gallery--grid--body').data('gallery-type')

        if ( galleryType !== 'image' ) return

        images = $('.gallery--grid--body[data-gallery="' + currentGallery + '"] .gallery-grid--item')
            .map(function () {
                return $(this).data('image');
            }).get();

        currentIndex = $(this).index();

        $('.gallery-popup-wrapper').fadeIn();
        $('.gallery-popup img').attr('src', images[currentIndex]);
        $('body').addClass('popup-open');
    });

    // === NAVIGÁCIA ===
    $('.gallery-popup--arrow:first button').on('click', function (e) {
        e.stopPropagation();
        currentIndex = (currentIndex - 1 + images.length) % images.length;
        $('.gallery-popup img').attr('src', images[currentIndex]);
    });

    $('.gallery-popup--arrow:last button').on('click', function (e) {
        e.stopPropagation();
        currentIndex = (currentIndex + 1) % images.length;
        $('.gallery-popup img').attr('src', images[currentIndex]);
    });

    // === ZATVORENIE ===
    $('.gallery-popup-wrapper').on('click', function () {
        $(this).fadeOut();
        $('body').removeClass('popup-open');
    });

    $('.gallery-popup img').on('click', function (e) {
        e.stopPropagation();
    });

    $(document).on('keyup', function (e) {
        if (e.key === 'Escape') {
            $('.gallery-popup-wrapper').fadeOut();
            $('body').removeClass('popup-open');
        }
    });
});